/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Launch_Top_PickInputs */

const en_directory_launch_top_pick = /** @type {(inputs: Directory_Launch_Top_PickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Top pick`)
};

const zh_directory_launch_top_pick = /** @type {(inputs: Directory_Launch_Top_PickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`本月精选`)
};

/**
* | output |
* | --- |
* | "Top pick" |
*
* @param {Directory_Launch_Top_PickInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_launch_top_pick = /** @type {((inputs?: Directory_Launch_Top_PickInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Launch_Top_PickInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_launch_top_pick(inputs)
	return zh_directory_launch_top_pick(inputs)
});
export { directory_launch_top_pick as "directory.launch.top_pick" }